__webpack_require__.p = "https://staging.sovryn.app/";